/**
 * Curation Service
 * 큐레이션 관련 API 호출
 */
import { apiClient } from '@/lib/api-client';
import type { ApiResponse, PaginationResponse } from '@/lib/types/api';
import type {
  CurationPickResponse,
  CurationPickAllResponse,
  CurationSectionsResponse,
  CurationByTopicResponse,
  ReportItem,
} from '@/types/report';

class CurationService {
  /**
   * 에디터 픽 큐레이션 조회
   * GET /curations/pick
   */
  async getCurationPick(size: number = 10): Promise<ApiResponse<CurationPickResponse>> {
    return apiClient.get<CurationPickResponse>(`/curations/pick?size=${size}`);
  }

  /**
   * 에디터 픽 큐레이션 페이징 조회
   * GET /curations/pick/page
   */
  async getCurationPickPage(
    page: number = 1,
    size: number = 12
  ): Promise<ApiResponse<PaginationResponse<ReportItem>>> {
    return apiClient.get<PaginationResponse<ReportItem>>(
      `/curations/pick/page?page=${page}&size=${size}`
    );
  }

  /**
   * 에디터 픽 전체 조회
   * GET /curations/pick/all
   */
  async getCurationPickAll(): Promise<ApiResponse<CurationPickAllResponse>> {
    return apiClient.get<CurationPickAllResponse>('/curations/pick/all');
  }

  /**
   * 큐레이션 섹션 목록 조회
   * GET /curations/sections
   */
  async getCurationSections(): Promise<ApiResponse<CurationSectionsResponse>> {
    return apiClient.get<CurationSectionsResponse>('/curations/sections');
  }

  /**
   * 토픽별 큐레이션 조회
   * GET /curations/by-topic
   */
  async getCurationByTopic(
    topic: number,
    size: number = 10
  ): Promise<ApiResponse<CurationByTopicResponse>> {
    return apiClient.get<CurationByTopicResponse>(
      `/curations/by-topic?topic=${encodeURIComponent(topic)}&size=${size}`
    );
  }

  /**
   * 토픽별 큐레이션 페이징 조회
   * GET /curations/by-topic/page
   */
  async getCurationByTopicPage(
    topic: number,
    page: number = 1,
    size: number = 12
  ): Promise<ApiResponse<PaginationResponse<ReportItem>>> {
    return apiClient.get<PaginationResponse<ReportItem>>(
      `/curations/by-topic/page?topic=${encodeURIComponent(topic)}&page=${page}&size=${size}`
    );
  }
}

// 싱글톤 인스턴스
export const curationService = new CurationService();

